import { Action } from '@ngrx/store';
import { IContractModel } from '../../models/account/IContractModel';
import { Sorting } from '../../models/account/sortingTypes.model';

export const GET_CONTRACTS = '[CONTRACTS] Get Contracts';
export const GET_CONTRACTS_SUCCESS = '[CONTRACTS] Get Contracts Success';
export const GET_CONTRACTS_ERROR = '[CONTRACTS] Get Contracts Error';
export const SORT_CONTRACTS_INIT = '[CONTRACTS] Sort Contracts init';
export const SORT_CONTRACTS_COMPLETED = '[CONTRACTS] Sort Contracts completed';

// Actions for Getting Contracts
export class GetContracts implements Action {
  readonly type = GET_CONTRACTS;
}

export class SortContractsInit implements Action {
  readonly type = SORT_CONTRACTS_INIT;
  constructor(public payload: Sorting) {}
}

export class SortContractsCompleted implements Action {
  readonly type = SORT_CONTRACTS_COMPLETED;
  constructor(public payload: IContractModel[]) {}
}

export class GetContractsSuccess implements Action {
  readonly type = GET_CONTRACTS_SUCCESS;
  constructor(public payload: IContractModel[]) {}
}

export class GetContractsError implements Action {
  readonly type = GET_CONTRACTS_ERROR;
  constructor(public payload: string) {}
}

export type ActionsContracts =
  | GetContracts
  | GetContractsSuccess
  | GetContractsError
  | SortContractsInit
  | SortContractsCompleted;
